import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()
  
  // Check if mobile viewport for shorter toast duration
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 1024

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      position="top-center"
      toastOptions={{
        duration: isMobile ? 2000 : 3000, // Shorter duration on mobile
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:z-[90]",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      style={{
        // Set z-index lower than mobile navigation (z-[100])
        zIndex: 90,
      }}
      {...props} />
  );
}

export { Toaster, toast }
